import { createAction, props } from '@ngrx/store';

export const fetchChargeCards = createAction('[Emobility] Fetch charge cards');
export const blockChargeCard = createAction(
  '[Emobility] Block charge card',
  props<{ cardId?: string }>()
);
